module.exports = __webpack_public_path__ + "static/media/05.771e0dd3.mp3";